<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
@if (resultPresent) {
  <div>
    <div class="searchResults">
      <div class="searchResultsPresent">
        <div class="accordions w-100">
          @for (item of searchResult.products; track item) {
            <div
              class="accordion"
              [ngClass]="{ selected: false }"
              >
              <div class="accordion-header" (click)="toggleAccordion(item)">
                <h3 class="accordion-title">{{ item.title }}</h3>
                <span class="accordion-icon">{{ item.selected ? "-" : "+" }}</span>
              </div>
              @if (item.selected) {
                <div class="accordion-content">
                  <div class="content-data" [innerHTML]="item.content"></div>
                  @for (item of item.contentDocuments; track item; let i = $index) {
                    <div>
                      <div>
                        @if (item.type == 'PAGE_LINK') {
                          <a
                            href="{{ item.url }}"
                            target="_blank"
                            class="linkText"
                            >{{ item.linkText }}</a
                            >
                          }
                        </div>
                      </div>
                    }
                    @if (showHeading(item?.contentDocuments)) {
                      <h1>
                        <p class="resources-text">Resources</p>
                      </h1>
                    }
                    @for (item of item.contentDocuments; track item; let i = $index) {
                      <div>
                        @if (
                          item.type == 'PDF' ||
                          item.type == 'YOUTUBE_VIDEO' ||
                          item.type == 'VIDEO'
                          ) {
                          <h1
                            >
                            @if (item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO') {
                              <p
                                class="resources-text"
                                >
                                {{ item.linkText }}
                              </p>
                            }
                          </h1>
                        }
                        <div>
                          @if (item.type == 'PDF') {
                            <div
                              class="document-info d-flex flex-wrap justify-content-between"
                              >
                              @if (item.type == 'PDF') {
                                <a
                                  href="{{ item.url }}"
                                  target="_blank"
                                  class="linkText"
                                  >{{ item.linkText }}</a
                                  >
                                }
                                <a href="{{ item.url }}" class="viewAllText" target="_blank"
                                  >View
                                  <img
                                    src="/icons/viewIconNew.svg"
                                    width="15"
                                    height="20"
                                  /></a>
                                </div>
                              }
                            </div>
                            @if (item.type == 'YOUTUBE_VIDEO') {
                              <div class="youtube_video">
                                <iframe
                                  width="345"
                                  class="iframe-youtube"
                                  allowfullscreen=""
                                  height="194"
                                  [attr.src]="item?.url | safe : 'resourceUrl'"
                                  >
                              </iframe>
                            </div>
                          }
                          @if (item.type == 'VIDEO') {
                            <div class="youtube_video">
                              <iframe
                                width="345"
                                class="iframe-youtube"
                                allowfullscreen=""
                                height="194"
                                [attr.src]="item?.url | safe : 'resourceUrl'"
                                >
                              </iframe>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
